class ScrollSpy extends HTMLElement {
  constructor() {
    super();
    this.container
    this.headerHeight = document.querySelector('sticky-header')?.getBoundingClientRect().height + 40
    this.navItems  = this.querySelectorAll('.scroll-spy__item')
    this.spyItems = this.querySelectorAll('.spy-item')
    this.scrollNavigation = this.querySelector('.scroll-spy-navigation')
    this.itemListContainer = this.querySelector('.scroll-spy__list')
    this.markline = this.querySelector('.mark-line')
    this.itemLength = this.querySelectorAll('.scroll-spy__item').length
    this.activeIndex = 0
    this.activeNavItem = this.querySelector('.scroll-spy__item.active')
    this.activeSpyItem = this.querySelector('.spy-item.active')
    this.calledSetScroll = false
    this.currentActiveInex = -1;
    if(this.navItems.length > 1){
      this.init()
      window.addEventListener('scroll',this.onScroll.bind(this))
    }
    // this.onScroll()
  }
  onScroll(){
    if(this.calledSetScroll) {
      this.calledSetScroll = false
      return
    }
    let scrollY =  window.scrollY + this.headerHeight
    let spyContainer = this
    let isMoved = false
    this.spyItems.forEach( function(item){
      if(isMoved) {
        return
      }
      const nextItem = spyContainer.querySelector(`.spy-item[data-index='${parseInt(item.dataset.index) + 1}']`)
      if(nextItem) {
        if(item.offsetTop <= scrollY && scrollY < nextItem.offsetTop) {
          spyContainer.navigation(item.dataset.index)
          spyContainer.updateMarkLine(item.dataset.index)
          isMoved = true
        } else if(item.offsetTop > scrollY) {
          spyContainer.navigation(0)
          spyContainer.updateMarkLine(0)
          isMoved = true
        }
      } else {
        spyContainer.navigation(item.dataset.index)
        spyContainer.updateMarkLine(item.dataset.index)
      }    
    })
  }
  onButtonClick(e){
    e.preventDefault()
    this.activeNavItem = e.target
    this.navigation(this.activeNavItem.dataset.index)
    this.setScroll(this.activeNavItem.dataset.index)
    this.updateMarkLine(this.activeNavItem.dataset.index)
  }
  navigation(index) {
    this.activeIndex = index
    this.querySelector('.scroll-spy__item.active')?.classList.remove('active')
    this.querySelector(`.scroll-spy__item[data-index="${this.activeIndex}"]`).classList.add('active')
    this.querySelector(`.spy-item[data-index="${this.activeIndex}"]`).classList.add('active')
    this.activeSpyItem = this.querySelector(`.spy-item[data-index="${this.activeIndex}"]`)
  }
  setScroll(index){
    this.calledSetScroll = true
    window.scrollTo(0,this.querySelector(`.spy-item[data-index="${index}"]`).offsetTop - this.headerHeight)
  }
  updateMarkLine(index){
    if(this.currentActiveInex == index) {
      return
    }
    if(index != undefined) {
      this.markline.style.height = this.activeNavItem.getBoundingClientRect().height + 'px'
      let top = 0
      for (const item of this.navItems) {
        if(item.dataset.index == index || item.dataset.index === undefined) {
          break
        }
        top += item.getBoundingClientRect().height
      }
      top += 3 * parseInt(index)
      this.markline.style.top = top + "px"
      this.currentActiveInex = index
    }
  }
  init(){
    this.scrollNavigation.style.top = `${this.headerHeight}px`
    this.updateMarkLine(this.activeIndex)
    this.spyItems.forEach((item,index)=>{
      item.setAttribute('data-index',index)
    })
    this.navItems.forEach((navItem, index) =>{
      navItem.setAttribute('data-index',index)
      navItem.addEventListener('click', this.onButtonClick.bind(this))
    });
    this.updateMarkLine()
  }
}

customElements.define('scroll-spy', ScrollSpy);

document.addEventListener("DOMContentLoaded", function() {
  const inputCtrl = document.querySelector(".nf-faq-banner-search-input input");
  const faqItemChecks = document.querySelectorAll('.faq__item input[type="checkbox"]');
  const faqItemQuestions = document.querySelectorAll(".faq__item .collapsible-toggle");
  const faqItemAnswers = document.querySelectorAll(".faq__item .collapsible[itemprop='acceptedAnswer'] p");
  const search = () => {
    const searchValue = inputCtrl?.value;
    for (const [index, element] of faqItemQuestions.entries()) {
      if(element.innerText.indexOf(searchValue) === -1) {
        if(faqItemAnswers[index].innerText.indexOf(searchValue) === -1) {
          element.classList.remove("show");
          faqItemChecks[index].checked = false;
          continue;
        }
      }
      element.classList.add("show");
    }
  }
  inputCtrl?.addEventListener("keyup", search);
});